<template>
  <v-form ref="form">
    <v-row class="containerTableCafezal">
      <v-col cols="12" class="mt-6 mb-8">
        <h3 class="black--text mb-4">Seguro Cafezal</h3>
        <v-data-table
          :headers="headerCafezal"
          :items="formCosts.quotationCostsCafezal"
          no-data-text="Nenhuma Cotação foi encontrada"
          loading-text="Carregando Cotações..."
          :options.sync="options"
          :server-items-length="formCosts.quotationCostsCafezal.lenght"
          class="quotation-table base__datatable cafezal cursor-cafezal"
          item-key="item.index"
          :footer-props="{ 'items-per-page-options': [25, 50, 100, 250, 500] }"
          :hide-default-footer="true"
          :hide-default-header="true"
          :disabled="true"
          style="cursor: default"
        >
          <template v-slot:[`item.index`]="{ item }">
            {{ "1." + (formCosts.quotationCostsCafezal.indexOf(item) + 1) }}
          </template>
          <template #header="{ }">
            <thead class="table-header">
              <tr style="">
                <th
                  v-for="(h, index) in headerCafezal.filter(h => !h.subtitle)"
                  :key="index"
                  :width="h.width"
                  :rowspan="h.extracolspan ? 1 : 2"
                  :colspan="h.extracolspan ? 4 : 1"
                  class="text-center"
                  v-bind:class="{ coverage: h.extracolspan }"
                >
                  <span v-if="!h.extracolspan">
                    {{ h.text }}
                  </span>
                  <span v-else-if="h.extracolspan">
                    Coberturas
                  </span>
                </th>
              </tr>
              <tr>
                <th
                  v-for="(h, index) in headerCafezal.filter(
                    h => h.subtitle || h.extracolspan
                  )"
                  :key="index"
                  class="subtitle"
                  style=""
                >
                  <span>
                    {{ h.text }}
                  </span>
                </th>
              </tr>
            </thead>
          </template>
          <template v-slot:[`item.area_segurada`]="{ item }">
            {{ asNumberString(item.area_segurada) }}
          </template>
          <template v-slot:[`item.valor_planta`]="{ item }">
            {{ asNumberString(item.valor_planta) }}
          </template>
          <template v-slot:[`item.granizo`]="{ item }">
            {{ item.granizo > 0 ? asNumberString(item.granizo) : "-" }}
          </template>
          <template v-slot:[`item.granizo_geada`]="{ item }">
            {{ item.granizo_geada > 0 ? asNumberString(item.granizo_geada) : "-" }}
          </template>
          <template v-slot:[`item.perda_producao_futura`]="{ item }">
            {{ asNumberString(item.perda_producao_futura) }}
          </template>
          <template v-slot:[`item.tratamento_fitossanitario`]="{ item }">
            {{ asNumberString(item.tratamento_fitossanitario) }}
          </template>
          <template v-slot:[`item.premio_total`]="{ item }">
            {{ asNumberString(item.premio_total) }}
          </template>
          <template v-slot:[`item.subvencao_federal`]="{ item }">
            {{ asNumberString(item.subvencao_federal) }}
          </template>
          <template v-slot:[`item.subvencao_estadual`]="{ item }">
            {{ asNumberString(item.subvencao_estadual) }}
          </template>
          <template v-slot:[`item.premio_segurado`]="{ item }">
            {{ asNumberString(item.premio_segurado) }}
          </template>
          <template v-slot:[`item.investimento`]="{ item }">
            {{ asNumberString(item.investimento) }}
          </template>
          <template v-slot:[`item.visible`]="{ item }">
            <v-row class="buttonAction">
              <v-col>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <BaseButton
                      color="secondary"
                      class="base-input-file__button mr-1 px-0"
                      @click="editRow(item)"
                      v-on="on"
                    >
                      <v-icon size="12"> fas fa-pencil-alt </v-icon>
                    </BaseButton>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
              </v-col>
              <v-col>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <BaseButton
                      color="secondary"
                      class="base-input-file__button mr-1 px-0"
                      @click="deleteRow(item)"
                      v-on="on"
                    >
                      <v-icon size="12"> fas fa-trash-alt </v-icon>
                    </BaseButton>
                  </template>
                  <span>Excluir</span>
                </v-tooltip>
              </v-col>
              <v-col>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <BaseButton
                      color="secondary"
                      class="base-input-file__button mr-1 px-0"
                      @click="duplicateRow(item)"
                      v-on="on"
                    >
                      <v-icon size="12"> fa-thin fa-copy </v-icon>
                    </BaseButton>
                  </template>
                  <span>Duplicar</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <ModalDeleteLineTable v-model="showDeleteModal" @close="closeModal" />
  </v-form>
</template>
<script>
const tableHeaders = [
  { text: "Id", value: "index", sortable: false, width: "10px" },
  { text: "Seguradora", value: "seguradora.nome", sortable: false, width: "80px" },
  { text: "Área Segurada (ha)", value: "area_segurada", sortable: false },
  { text: "Valor da Planta (R$)", value: "valor_planta", sortable: false },
  {
    text: "Granizo (R$)",
    value: "granizo",
    sortable: false,
    extracolspan: true
  },
  {
    text: "Granizo e Geada  (R$)",
    value: "granizo_geada",
    sortable: false,
    subtitle: true
  },
  {
    text: "Perda Produção Futura (R$)",
    value: "perda_producao_futura",
    sortable: false,
    subtitle: true,
    width: "80px"
  },
  {
    text: "Tratamento Fitossanitário (R$)",
    value: "tratamento_fitossanitario",
    sortable: false,
    subtitle: true
  },
  {
    text: "POS",
    value: "tipo_pos.nome",
    sortable: false
  },
  { text: "Prêmio Total (R$)", value: "premio_total", sortable: false },
  {
    text: "Subvenção Federal (R$)",
    value: "subvencao_federal",
    sortable: false
  },
  {
    text: "Subvenção Estadual (R$)",
    value: "subvencao_estadual",
    sortable: false
  },
  { text: "Prêmio Segurado (R$)", value: "premio_segurado", sortable: false },
  { text: "Investimento (R$/ha)", value: "investimento", sortable: false },
  { text: "Ações", value: "visible", sortable: false }
];

import {
  asNumberString,
  formatExpirationDate,
  formatDDMMYYYYToIsoDate
} from "@/utils/formats.js";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { maskDate } from "@/utils/masks.js";
import { dateTermValid, requiredInput } from "@/utils/rules.js";
import { CommonPayload } from "@/mixins/PayloadDataTableMixin";
import ModalDeleteLineTable from "../components_agro/ModalDeleteLineTable.vue";
export default {
  data() {
    return {
      headerCafezal: tableHeaders,
      formatExpirationDate,
      maskDate,
      timeout: null,
      dateTermValid,
      formatDDMMYYYYToIsoDate,
      initializeFilter: false,
      currentTab: 1,
      requiredInput,
      asNumberString,
      showDeleteModal: false,
      shouldDeleteData: false
    };
  },
  components: {
    ModalDeleteLineTable
  },
  props: {
    value: {
      type: Object
    },
    formCost: {
      type: Object
    }
  },
  mixins: [LoadingRequest, CommonPayload],
  computed: {
    ...mapState("quotation", [
      "infoCostQuotation",
      "currentQuotation",
      "statusCurrentQuotation",
      "listQuotation"
    ]),
    ...mapState(["nameOptionsDataTable", "filterDataTable"]),
    formCosts: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    ...mapActions("quotation", [
      "requestCurrentQuotation",
      "requestStatusCurrentQuotation",
      "requestListQuotation"
    ]),
    async fetchStatusQuotation() {
      await this.requestStatusCurrentQuotation(this.$route.params.id);
    },
    editRow(item) {
      this.$emit("edit", item);
    },
    closeModal(valor) {
      this.shouldDeleteData = valor;
      this.showDeleteModal = false;
      this.$emit("modal-closed");
    },
    deleteRow(item) {
      this.showDeleteModal = true;

      this.$once("modal-closed", () => {
        if (this.shouldDeleteData) {
          this.$emit("delete", item);
        }
      });
    },
    duplicateRow(item) {
      this.$emit("duplicate", item);
    }
  }
};
</script>
<style lang="sass">
.containerTableCafezal
  min-width: 90% !important
  margin: 0 auto !important
.quotation-table.cafezal
  background-color: #FFFFFF !important
  table
    width: 100% !important
    table-layout: fixed
    overflow-x: none
.base__datatable.v-data-table.theme--light.cafezal
  thead tr th
    font-size: 10px
    text-align: center
  thead tr th:last-child
    width: 150px
    padding-left: 18px
  tbody tr td
    font-size: 11px
    margin-right: 2px !important
  .coverage
    padding: 2px
    font-size: 10px
    height: 24px
    background-color: #EBEEF2 !important
.toolbar-quotation-info
  display: flex
  justify-content: right
.cursor-cafezal
  tbody tr td
    cursor: default
.buttonAction
  display: flex
  flex-wrap: nowrap
</style>
